export default __webpack_public_path__ + "static/media/doll.d84deba7.mp3";